import logo from './KennethLangdon_logo_only.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          <code>Kenneth Langdon</code>
        </p>
        <a
          className="App-link"
          href="mailto:klangdon@kennethlangdon.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Email Me
        </a>
      </header>
    </div>
  );
}

export default App;
